import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import MainTitle from '../../../../components/MainTitle';
import './ProposalPreview.scss';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MiniPagination from '../../../../components/MiniPagination';
import { Document, Page } from 'react-pdf/dist/umd/entry.webpack';
import { cleanProposalData } from '../../../../store/actions/ProposalsAction';
/* import { Document ,Page} from 'react-pdf/dist/esm/entry.webpack';
local pdf 
*/
const ProposalPreview = ({
  pdfValue,
  setCreateView,
  setShowPreview,
  cleanProposalData,
  selectedProposal,
  newProposal,
}) => {
  const tablet = useMediaQuery('(max-width: 836px)');
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [idProposal, setIdProposal] = useState('');
  const [link, setLinkProposal] = useState('');

  useEffect(() => {
    if (selectedProposal && Object.values(selectedProposal).length > 0) {
      setIdProposal(selectedProposal.id);
      setLinkProposal(selectedProposal.pdfUrl);
    } else {
      setIdProposal(newProposal.id);
      setLinkProposal(newProposal.pdfUrl);
    }
  }, [selectedProposal, newProposal]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
  };

  const letfFunc = () => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber - 1);
    }
  };
  const rightFunc = () => {
    if (pageNumber < numPages - 1) {
      setPageNumber(pageNumber + 1);
    }
  };

  return (
    <section className="PP">
      <div style={{ marginBottom: 34, maxWidth: 544 }}>
        <div
          className="PP-header-arrowBack"
          onClick={() => {
            setCreateView && setCreateView(false);
            setShowPreview && setShowPreview(false);
            cleanProposalData();
          }}
        >
          <img src="/img/admin/arrow-back.svg" alt="arrow-back" />
          <p>Ir a listado de propuestas económicas</p>
        </div>
        <MainTitle
          title="Previsualización"
          subtitle="Esta es una vista a tamaño real del documento que podrás compartir con tus clientes."
        />
      </div>
      {/*             {!tablet && <p className="PP-text">Estatus de la propuesta económica:<span className="PP-marked">Borrador</span></p>}
       */}
      {/*  <div className="PP-mtxt"><p className="PP-text">Estatus:<span className="PP-marked">Borrador</span></p></div>
       */}
      <div className="PP-container">
        <div className="PP-preview">
          {tablet && (
            <div className="PP-Topinfo">
              <MiniPagination
                color="blue"
                actualNum={pageNumber}
                totalText={numPages}
                total={numPages - 1}
                letfFunc={letfFunc}
                rightFunc={rightFunc}
              />
            </div>
          )}
          <Document
            className="documento"
            //file={"https://firebasestorage.googleapis.com/v0/b/contactaabogado-a1be9.appspot.com/o/PDF%2FOUpCZk1U4zNa269IvAzcOwNkaPF2%2FJuan%20Carlos.pdf?alt=media&token=e2c07d74-21c2-48b2-a3fc-b952890e529a"}
            file={pdfValue}
            /*  file={{ url: 'https://firebasestorage.googleapis.com/v0/b/contactaabogado-a1be9.appspot.com/o/PDF%2FOUpCZk1U4zNa269IvAzcOwNkaPF2%2FJuan%20Carlos.pdf?alt=media&token=e2c07d74-21c2-48b2-a3fc-b952890e529a', 
                        httpHeaders: {
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods":"GET,HEAD,OPTIONS,POST,PUT",
                            "Access-Control-Allow-Headers":"Origin, X-Requested-With, Content-Type, Accept, Authorization"
                    
                    }}} */
            onLoadSuccess={onDocumentLoadSuccess}
            options={options}
          >
            <Page className="paginas" pageNumber={pageNumber + 1} />
          </Document>

          {!tablet && (
            <MiniPagination
              color="blue"
              actualNum={pageNumber}
              totalText={numPages}
              total={numPages - 1}
              letfFunc={letfFunc}
              rightFunc={rightFunc}
            />
          )}
        </div>
        <div className="PP-share">
          {/* <div className="PP-share_container PP-marginBottom_4">
                        <img src="/img/socialMediaIcons/enviar.svg" alt="enviar"/>
                        <p className="PP-share_title">Enviar</p>
                    </div> */}
          <a
            className="PP-share_container PP-marginBottom_4"
            href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
              link
            )}`}
            data-action="share/whatsapp/share"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <img src="/img/socialMediaIcons/whatsapp.svg" alt="whatsapp" />
            <p className="PP-share_title">WhatsApp</p>
          </a>
          <a className="PP-share_container PP-marginBottom_4" href={`mailto:`}>
            <img src="/img/socialMediaIcons/correo.svg" alt="email" />
            <p className="PP-share_title">Email</p>
          </a>
          <div
            className="PP-share_container"
            onClick={() => {
              fetch(link)
                .then(function (resp) {
                  return resp.blob();
                })
                .then(function (blob) {
                  saveAs(blob, `${idProposal}.pdf`);
                });
            }}
          >
            <img src="/img/socialMediaIcons/descargar.svg" alt="descargar" />

            <p className="PP-share_title">Descargar</p>
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  selectedProposal: state.proposalsReducer.selectedProposal,
  newProposal: state.proposalsReducer.newProposalData,
});
const mapDispatchToProps = (dispatch) => ({
  cleanProposalData: () => dispatch(cleanProposalData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProposalPreview);
